<template>
  <div class="container">
    <h2>{{ page.Title }}</h2>
    <!--  Accept terms text -->
    <p class="text">{{ page.Questions[6].description }}</p>
    <div v-if="page.Content" v-html="page.Content"></div>
    <div class="row">
      <div class="col-lg-10">
        <!--  Accept newsletter checkbox / Contact me -->
        <DoCheckbox
          v-model="page.Questions[0].Value"
          :value="page.Questions[0].Value"
          :id="page.Questions[0].QID"
          :config="page.Questions[0].Config"
          :options="page.Questions[0].Options"
        />
      </div>
      <div class="col-lg-9">
        <!-- Accept terms checkbox -->
        <DoCheckbox
          v-model="page.Questions[4].Value"
          :value="page.Questions[4].Value"
          :id="page.Questions[4].QID"
          :config="page.Questions[4].Config"
          :options="page.Questions[4].Options"
        />
      </div>
    </div>
    <div class="row mt-4" v-if="!this.$store.state.hasNoCPR">
      <div class="col-lg-10">
        <h2>{{ page.Questions[7].AdditionalInfoHeader }}</h2>
        <p>{{ page.Questions[8].AdditionalInfoDescription }}</p>
      </div>
    </div>
    <div class="row" style="margin-top: 15px" v-else>
      <div class="col-lg-10">
        <h2>{{ page.Questions[10].AdditionalInfoHeaderAll }}</h2>
        <p>{{ page.Questions[11].AdditionalInfoDescriptionAll }}</p>
      </div>
    </div>
    <div class="row" style="margin-bottom: 25px; margin-top: -15px">
      <!--  Reg + kontonr inputs -->
      <div class="col-lg-8 d-flex">
        <DoPaymentType :page="page" />
      </div>
    </div>
    <div class="row">
      <!--  Accept terms text -->
      <div
        class="col-lg-10 mt-4"
        style="margin-bottom: -30px"
        v-if="this.$store.state.employment == 5"
      >
        <p class="text">{{ page.Questions[1].txt }}</p>
      </div>
      <!-- If Student and if used for internal purpose-->
      <div
        class="col-lg-6"
        v-if="
          this.$store.state.pageData.UseInternal == 'true' &&
          this.$store.state.employment == 3
        "
      >
        <!--  Remarks textarea -->
        <DoTextArea
          v-model="page.Questions[5].Value"
          :value="page.Questions[5].Value"
          :id="page.Questions[5].QID"
          :config="page.Questions[5].Config"
          :options="page.Questions[5].Options"
        />
      </div>
      <div class="col-lg-6" v-if="this.$store.state.employment != 3">
        <!--  Remarks textarea -->
        <DoTextArea
          v-model="page.Questions[5].Value"
          :value="page.Questions[5].Value"
          :id="page.Questions[5].QID"
          :config="page.Questions[5].Config"
          :options="page.Questions[5].Options"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    inject: {
      $validator: '$validator',
    },
    props: {
      page: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {};
    },
    methods: {
      ManageRegAndAccount: function (e) {
        if (e == false) {
          this.page.Questions[2].Value = '';
          this.page.Questions[3].Value = '';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .text {
    color: $black;
  }

  .reg {
    flex-grow: 0;
    margin-right: 30px;
    width: 70px;
  }

  .account {
    flex-grow: 1;
  }
</style>
